var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "leftReview bg-white mb-8 rounded-lg shadow-md h-64 p-4 mt-7",
    },
    [
      _c("CardBodyItem", {
        staticClass: "mb-0.5",
        attrs: { label: "Reviews", totalNumber: _vm.ratings.length },
      }),
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.ratings, loading: _vm.$apollo.loading } },
        [
          _vm.showEmptyListPlaceholder
            ? _c(
                "p",
                { staticClass: "text-md my-16 text-primary-black text-center" },
                [_vm._v("There are currently no reviews.")]
              )
            : _vm._l(_vm.ratings, function (rating) {
                return _c("ContractorReview", {
                  key: rating.id,
                  attrs: {
                    rating: rating,
                    currentUserRole: _vm.currentUserRole,
                    currentUserId: _vm.currentUserId,
                    contractorId: _vm.contractorId,
                  },
                  on: { reviewDeleted: _vm.refetchReviews },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "taskDeatils",
                        fn: function () {
                          return [
                            rating.public_project_details
                              ? _c("ReviewDetails", {
                                  attrs: {
                                    projectDetails:
                                      rating.public_project_details,
                                    projectActivity: rating.project_activity,
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
          _vm.dialog
            ? _c("ReviewModal", {
                attrs: {
                  contractorId: _vm.contractorId,
                  currentUserId: _vm.currentUserId,
                },
                on: {
                  close: _vm.toggleReviewModal,
                  reviewCreated: _vm.refetchReviews,
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }